"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrustWallet = void 0;
const types_1 = require("@web3-react/types");
class TrustWallet extends types_1.Connector {
    get connected() {
        var _a, _b;
        return !!((_b = (_a = this.provider) === null || _a === void 0 ? void 0 : _a.isConnected) === null || _b === void 0 ? void 0 : _b.call(_a));
    }
    constructor({ actions, onError }) {
        super(actions, onError);
    }
    activate(desiredChainIdOrChainParameters) {
        if (!this.provider) {
            window.open('https://trustwallet.com/browser-extension/', '_blank');
            return;
        }
        const desiredChainId = typeof desiredChainIdOrChainParameters === 'number'
            ? desiredChainIdOrChainParameters
            : desiredChainIdOrChainParameters === null || desiredChainIdOrChainParameters === void 0 ? void 0 : desiredChainIdOrChainParameters.chainId;
        if (this.connected && desiredChainId && desiredChainId === this.parseChainId(this.provider.chainId)) {
            const desiredChainIdHex = `0x${desiredChainId.toString(16)}`;
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return this.provider.request({
                method: 'wallet_switchEthereumChain',
                params: [{ chainId: desiredChainIdHex }],
            }).catch((error) => __awaiter(this, void 0, void 0, function* () {
                console.log('err!', error);
                if (error.code === 4902 && typeof desiredChainIdOrChainParameters !== 'number') {
                    // if we're here, we can try to add a new network
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    return this.provider.request({
                        method: 'wallet_addEthereumChain',
                        params: [Object.assign(Object.assign({}, desiredChainIdOrChainParameters), { chainId: desiredChainIdHex })],
                    });
                }
                throw error;
            }));
        }
        return Promise.all([
            this.provider.request({ method: 'eth_chainId' }),
            this.provider.request({ method: 'eth_requestAccounts' }),
        ]).then(([chainId, accounts]) => {
            const receivedChainId = this.parseChainId(chainId);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            if (!desiredChainId || desiredChainId === receivedChainId) {
                return this.actions.update({ chainId: receivedChainId, accounts });
            }
            const desiredChainIdHex = `0x${desiredChainId.toString(16)}`;
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return this.provider.request({
                method: 'wallet_switchEthereumChain',
                params: [{ chainId: desiredChainIdHex }],
            }).catch((error) => __awaiter(this, void 0, void 0, function* () {
                console.log('err!', error);
                if (error.code === 4902 && typeof desiredChainIdOrChainParameters !== 'number') {
                    // if we're here, we can try to add a new network
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    return this.provider.request({
                        method: 'wallet_addEthereumChain',
                        params: [Object.assign(Object.assign({}, desiredChainIdOrChainParameters), { chainId: desiredChainIdHex })],
                    });
                }
                throw error;
            }));
        });
    }
    /** {@inheritdoc Connector.connectEagerly} */
    connectEagerly() {
        return __awaiter(this, void 0, void 0, function* () {
            this.isomorphicInitialize();
            if (!this.provider)
                return;
            return Promise.all([
                this.provider.request({ method: 'eth_chainId' }),
                this.provider.request({ method: 'eth_accounts' }),
            ])
                .then(([chainId, accounts]) => {
                if (accounts.length) {
                    this.actions.update({ chainId: this.parseChainId(chainId), accounts });
                }
                else {
                    throw new Error('No accounts returned');
                }
            })
                .catch((error) => {
                console.debug('Could not connect eagerly', error);
                this.actions.resetState();
            });
        });
    }
    detectProvider() {
        var _a, _b;
        this.provider = this.isTrust(window.ethereum) ||
            window.trustwallet ||
            ((_b = (_a = window.ethereum) === null || _a === void 0 ? void 0 : _a.providers) === null || _b === void 0 ? void 0 : _b.find((provider) => provider.isTrust || provider.isTrustWallet));
        if (this.provider) {
            return this.provider;
        }
    }
    isTrust(ethereum) {
        const isTrustWallet = !!(ethereum === null || ethereum === void 0 ? void 0 : ethereum.isTrust) || !!(ethereum === null || ethereum === void 0 ? void 0 : ethereum.isTrustWallet);
        if (!isTrustWallet)
            return;
        return ethereum;
    }
    isomorphicInitialize() {
        const provider = this.detectProvider();
        if (provider) {
            provider.on('connect', ({ chainId }) => {
                this.actions.update({ chainId: this.parseChainId(chainId) });
            });
            provider.on('disconnect', (error) => {
                var _a, _b;
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (_a = this.provider) === null || _a === void 0 ? void 0 : _a.request({ method: 'PUBLIC_disconnectSite' });
                this.actions.resetState();
                (_b = this.onError) === null || _b === void 0 ? void 0 : _b.call(this, error);
            });
            provider.on('chainChanged', (chainId) => {
                this.actions.update({ chainId: Number(chainId) });
            });
            provider.on('accountsChanged', (accounts) => {
                if (accounts.length === 0) {
                    // handle this edge case by disconnecting
                    this.actions.resetState();
                }
                else {
                    this.actions.update({ accounts });
                }
            });
        }
    }
    parseChainId(chainId) {
        return Number.parseInt(chainId, 16);
    }
}
exports.TrustWallet = TrustWallet;
